<template>
  <div class="app-container">
    <div class="main-content">
      <router-view></router-view>
    </div>
    <footer class="footer">
      <!-- ... existing code ... -->
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isMenuOpen: false
    }
  },
  computed: {
    is404Page() {
      return this.$route.name === 'NotFound'
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    }
  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}

.footer {
  margin-top: auto;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo img {
  height: 32px;
  width: auto;
}

.nav-links {
  display: flex;
  gap: 40px;
  align-items: center;
}

.nav-links a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  position: relative;
  padding: 5px 0;
}

.nav-links a.router-link-active {
  color: #42b983;
}

.nav-links a.router-link-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #42b983;
}

.primary-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.primary-btn:hover {
  background-color: #3aa876;
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
  }

  .nav-links.active {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    padding: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
}
</style>
<style>
.product-item {
  cursor: pointer;

}

.nav-item {
  cursor: pointer;
}

.consult-button {
  cursor: pointer;

}
</style>
<style>
.content-section {
  margin: 30px 0;
}

.Aichat {
  position: fixed;
  bottom: 0px;
  right: 50px;
  cursor: pointer;
  height: 80px;
  color: #000;
  width: 60px;
  background: #fff;
  border-radius: 10px;
  z-index: 9999;
  /* 增加这个值 */
}

.Aitext {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 60px;
  background: #fff;
  /* height: 70px; */
  cursor: pointer;
  color: #29AB0B;
  text-align: center;
  z-index: 10000;
  /* 为 Aitext 添加一个更高的 z-index */
}
</style>

ffmpeg -i input.gif -vf "scale=640:-1, fps=10" -lavfi "split[s0][s1];[s0]palettegen=max_colors=64[p];[s1][p]paletteuse=dither=bayer" -loop 0 -y compressed_loop.gif                